import * as ActionTypes from './ActionTypes'
import { apiGetPpiConfigurations, apiPostPpiProxy } from './Api'

/**
 * 
 * @returns 
 */
export function getPpiConfigurations() {
  return (dispatch, getState) => {
    apiGetPpiConfigurations().then(response => {
      dispatch({
        type: ActionTypes.VNPPI_SET_CONFIGURATIONS,
        configs: response.data
      })
    }).catch(error => {
      console.log(error)
    })
  }
}

/**
 * 
 * @param {*} apiFunc 
 * @param {*} integration 
 * @param {*} transaction 
 * @returns 
 */
export function postPpiProxy(apiFunc, integration, transaction) {
  return (dispatch, getState) => {
    apiPostPpiProxy(apiFunc, integration, transaction).then(response => {
      dispatch({
        type: ActionTypes.VNPPI_SET_CONFIGURATIONS,
        configs: response.data
      })
    }).catch(error => {
      console.log(error)
    })
  }
}

/**
 * 
 * @param {String} orderUuid 
 * @param {Array} payments 
 * @returns 
 */
export function setOrderPayments(orderUuid, payments) {
  return (dispatch) => {
    dispatch({
      type: ActionTypes.VNPPI_SET_ORDER_PAYMENTS,
      orderUuid: orderUuid,
      payload: payments
    })
  }
}